// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ConfiguracoesSistema_SaveResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/configuracoes_sistema/{save,create,update}
 *
 * The model echoes back the saved record — the ConfiguracoesSistema_SaveInput
 * payload with config_sistema_id populated by insert_id() on create
 * (Configuracoes_sistema_model::create / ::update_by_name return the input
 * object). Field set mirrors ConfiguracoesSistema_SaveInput.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ConfiguracoesSistema_SaveResponseDados {
config_sistema_id?: number
config_sistema_nome?: string
config_sistema_valor?: string
config_sistema_descricao?: string
config_sistema_franquia_id?: number
}

export type ConfiguracoesSistema_SaveResponse = ApiResponse<ConfiguracoesSistema_SaveResponseDados>;

registerResponseContract('ConfiguracoesSistema_SaveResponse', {
  config_sistema_id:          { type: 'number',  required: false },
  config_sistema_nome:        { type: 'string',  required: false },
  config_sistema_valor:       { type: 'string',  required: false },
  config_sistema_descricao:   { type: 'string',  required: false },
  config_sistema_franquia_id: { type: 'number',  required: false },
})
